/**
 * Every balance mutation must be represented by one of these transaction
 * types and recorded as an append-only ledger row. Nothing outside this
 * list is a valid reason for a balance to change.
 */
export const WALLET_TRANSACTION_TYPES = [
  "STARTER_GRANT",
  "DAILY_REWARD",
  "GAME_BET",
  "GAME_WIN",
  "MISSION_REWARD",
  "ADMIN_ADJUSTMENT",
  "REFUND",
] as const;

export type WalletTransactionType = (typeof WALLET_TRANSACTION_TYPES)[number];

/** Transaction types that increase the wallet balance. */
export const CREDIT_TRANSACTION_TYPES: ReadonlySet<WalletTransactionType> = new Set([
  "STARTER_GRANT",
  "DAILY_REWARD",
  "GAME_WIN",
  "MISSION_REWARD",
  "REFUND",
]);

/** Transaction types that decrease the wallet balance. */
export const DEBIT_TRANSACTION_TYPES: ReadonlySet<WalletTransactionType> = new Set([
  "GAME_BET",
]);

/** ADMIN_ADJUSTMENT may be positive or negative and is validated separately. */
